import { render, staticRenderFns } from "./ListItemPost.vue?vue&type=template&id=546db4f1&scoped=true&"
import script from "./ListItemPost.vue?vue&type=script&lang=js&"
export * from "./ListItemPost.vue?vue&type=script&lang=js&"
import style0 from "./ListItemPost.vue?vue&type=style&index=0&id=546db4f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546db4f1",
  null
  
)

export default component.exports